import styled from "@emotion/styled";

import { theme } from "../../ThemeProvider/CandyTheme/ThemeShorthand";

export const ControlDebugTooltipContentRoot = styled.div(props => ({
    width: 400,
    maxWidth: 400,
    overflow: "auto",
    maxHeight: 500,
    fontFamily: theme(props).typography.fontFamily.monospace,
    fontSize: "11px",
    margin: `-15px -20px`,
    padding: `8px`,
}));

export const BindingPath = styled.span(() => ({
    color: "blue",
    ":hover": {
        textDecoration: "underline",
        cursor: "pointer",
    },
}));

export const Divider = styled.div(props => ({
    textTransform: "uppercase",
    borderBottom: theme(props).border.solid,
    marginTop: 4,
}));

export const PropsContainer = styled.div(() => ({}));

export const Prop = styled.div(_ => ({
    display: "flex",
    flexDirection: "row",
    marginTop: 2,
}));

export const PropName = styled.span(props => ({
    flexShrink: 0,
    flexGrow: 0,
    color: theme(props).typography.secondary.color,
    width: 120,
    textOverflow: "ellipsis",
    overflow: "hidden",
}));

export const PropValue = styled.span(() => ({
    marginLeft: 4,
    flexShrink: 1,
    flexGrow: 1,
}));
